import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { auth } from '../utils/requests';
import { NOTE_VERSIONS_LIST, NOTE_VERSIONS_DETAIL, NOTE_VERSION_RESTORE } from '../api';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        detail: request_state(),
        restore: request_state(),
    },
    mutations: {
        ...request_mutations('list', 'list'),
        ...request_mutations('detail', 'detail'),
        ...request_mutations('restore', 'restore'),
        extend_list(state, data) {
            state.list.loading = false;
            state.list.error = {};
            state.list.data.results.push(...data.results);
            state.list.data.next = data.next;
        },
    },
    actions: {
        list({ commit }, {
            space_id, note_id, extend, page,
        }) {
            const url = NOTE_VERSIONS_LIST.replace('{space_id}', space_id).replace('{note_id}', note_id);
            commit('list_loading');
            return new Promise((resolve) => {
                axios.get(url, { params: { page }, ...auth() }).then((response) => {
                    commit(extend ? 'extend_list' : 'list_success', response.data);
                    resolve();
                }).catch(error => commit('list_error', error.response ? error.response.data : {}));
            });
        },
        detail({ commit }, { space_id, note_id, version_id }) {
            const url = NOTE_VERSIONS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id)
                .replace('{version_id}', version_id);

            commit('detail_loading');
            axios.get(url, auth()).then(response => commit('detail_success', response.data))
                .catch(error => commit('detail_error', error.response ? error.response.data : {}));
        },
        restore({ commit }, { space_id, note_id, version_id }) {
            const url = NOTE_VERSION_RESTORE
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id)
                .replace('{version_id}', version_id);

            commit('restore_loading');
            return new Promise((resolve) => {
                axios.put(url, {}, auth()).then((response) => {
                    commit('restore_success', response.data);
                    resolve();
                }).catch(error => commit('restore_error', error.response ? error.response.data : {}));
            });
        },
    },
};
